import { createFileRoute, notFound } from "@tanstack/react-router";
import { AnswerPage, buildAnswerHead } from "@/components/AnswerPage";
import { NotFoundPage } from "@/components/NotFoundPage";
import { getAnswer } from "@/lib/answersData";

export const Route = createFileRoute("/answers/$slug")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  loader: ({ params }) => {
    const entry = getAnswer(params.slug);
    if (!entry) throw notFound();
    return { entry };
  },
  head: ({ loaderData }) => {
    if (!loaderData?.entry) {
      return { meta: [{ title: "Answer not found | Colorado Web Impressions" }] };
    }
    return buildAnswerHead(loaderData.entry);
  },
  notFoundComponent: () => <NotFoundPage />,
  component: AnswerRoute,
});

function AnswerRoute() {
  const { entry } = Route.useLoaderData();
  return <AnswerPage entry={entry} />;
}
